import { Airports } from "@/constants";
import { PERMISSIONS } from "@/constants/permissions";

/**
 * Retrieves allowed airport permissions based on user codes.
 */
export const getAirportPermissions = (codes: string[], set = false) => {
    return codes.reduce<Airports[]>((prev, curr) => {
        if (
            curr ===
            (set
                ? PERMISSIONS.TR_SVC_WELCOME_TEAM_PASSENGERS_SET_IST_DATA
                : PERMISSIONS.TR_SVC_WELCOME_TEAM_PASSENGERS_GET_IST_DATA)
        )
            prev.push(Airports.IST);
        else if (
            curr ===
            (set
                ? PERMISSIONS.TR_SVC_WELCOME_TEAM_PASSENGERS_SET_SAW_DATA
                : PERMISSIONS.TR_SVC_WELCOME_TEAM_PASSENGERS_GET_SAW_DATA)
        )
            prev.push(Airports.SAW);
        return prev;
    }, []);
};
